module.exports = __webpack_public_path__ + "static/media/microsoft-logo.529babeb.svg";